export const CHANGE_APP_LANGUAGE = "APP/CHANGE_APP_LANGUAGE";

export function changeAppLanguage(language) {
  return {
    type: CHANGE_APP_LANGUAGE,
    language,
  };
}
